/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const SpendingCard = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M2 5C1.44772 5 1 5.44772 1 6V18C1 18.5523 1.44772 19 2 19H22C22.5523 19 23 18.5523 23 18V6C23 5.44772 22.5523 5 22 5H2ZM21.5 6.5H2.5V8H21.5V6.5ZM2.5 17.5V11H21.5V17.5H2.5ZM6.11413 12.963C6.58915 12.678 7.18259 12.678 7.65762 12.963L9.38587 14L11.5 12.7315L12.2717 14.0178L10.1576 15.2862C9.68259 15.5713 9.08915 15.5713 8.61413 15.2862L6.88587 14.2493L4.77174 15.5178L4 14.2315L6.11413 12.963ZM20 14H16V15.5H20V14Z"
                        fill={color}
                    />
                </svg>
        );
    };
